import React from 'react';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Box from '@amzn/awsui-components-console/box';
import Table from '@amzn/awsui-components-console/table';
import { ROADMAP_ITEMS, RoadmapItem } from '../../constants';
import styles from './Roadmap.module.scss';

const Roadmap: React.FC = () => (
  <section aria-label="Roadmap" className={styles.section} id="roadmap">
    <Container>
      <SpaceBetween size="l">
        <Box textAlign="center">
          <SpaceBetween size="xs">
            <Box
              variant="h2"
              fontSize="heading-xl"
              fontWeight="bold"
              textAlign="center"
            >
              Roadmap
            </Box>
            <Box variant="p" color="text-body-secondary" textAlign="center">
              What we are building and when you can expect it
            </Box>
          </SpaceBetween>
        </Box>
        <div className={styles.tableWrapper}>
          <Table<RoadmapItem>
            variant="borderless"
            trackBy="milestone"
            columnDefinitions={[
              {
                id: 'milestone',
                header: <Box fontWeight="bold">Milestone</Box>,
                width: 180,
                minWidth: 140,
                cell: (item) => <Box fontWeight="bold">{item.milestone}</Box>,
              },
              {
                id: 'capabilities',
                header: <Box fontWeight="bold">Capabilities</Box>,
                cell: (item) => <Box>{item.capabilities}</Box>,
              },
              {
                id: 'target',
                header: <Box fontWeight="bold">Target</Box>,
                width: 140,
                minWidth: 110,
                cell: (item) => (
                  <Box color="text-status-info">{item.target}</Box>
                ),
              },
            ]}
            items={ROADMAP_ITEMS}
            footer={
              <div className={styles.footerWrapper}>
                <Box textAlign="center" color="text-body-secondary" padding="m">
                  Data migration will not restrict your AST use. There are no
                  plans to make AST read only or deprecate it until you onboard
                  to LangHub. We will provide migration support and will keep
                  you updated well before we begin.
                </Box>
              </div>
            }
          />
        </div>
      </SpaceBetween>
    </Container>
  </section>
);

export default Roadmap;
